import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';

import { catchError, tap } from 'rxjs/operators';

import { Observable, throwError } from 'rxjs';

import { LossSessionComponent } from '../../authorization/loss-session/loss-session.component';
import { OperationConfirmationRequired } from '../../shared/confirmation/core/models/operation-confirmation-required.model';
import {
	AtypicalOperationException, BiometricsRegistrationClientExistsException,
	BiometricsRegistrationDataRefinementException, CaptchaException,
	CaptchaValidationException, InternetbankAppApplicationException,
	MiddleValidationException, MirPassIdUnregisteredException, NetworkConnectionProblemExecption, OperationConfirmationExpiredException,
	OperationConfirmationRequiredException, OperationConfirmationRequiredValidationException,
	OperationException, OperationInformationOutputContent, OperationInformationOutputException,
	OperationSignDocumentRequiredException, OperationWithErrorCodeException, OtherSystemPasswordException,
	SelfiePhotoRejectException, TechnicalException, TemporaryPasswordException,
	UnauthorizedException, UserLockedException,
} from '../exceptions/exceptions';
import { ConstantsService } from '../services/constants.service';
import { HttpClientExtension } from '../services/http-client-extension.service';


/* eslint-disable @typescript-eslint/no-explicit-any */
export class CoreHttpInterceptor implements HttpInterceptor {
	public constructor(
		public getUrlWithCustomRestSegment?: (url: string) => string,
	) {
	}

	public intercept(
		req: HttpRequest<any>,
		next: HttpHandler,
	): Observable<HttpEvent<any>> {

		const noCacheReq = req.clone({
			url: this.getUrlWithCustomRestSegment ? this.getUrlWithCustomRestSegment(req.url) : req.url,
			headers: req.headers
				.set('Cache-control', 'no-cache')
				.set('Cache-control', 'no-store')
				.set('Expires', '0')
				.set('Pragma', 'no-cache')
				.set('DateValue', new Date().valueOf()
					.toString()),
		});

		return next.handle(noCacheReq)
			.pipe(
				tap((event: HttpEvent<any>) => {
					if (event instanceof HttpResponse) {
						if (
							event.body &&
							event.body.operationId &&
							event.body.confirmationRequired
						) {
							const error: any = event.body;

							const operationConfirmationRequired: OperationConfirmationRequired = new OperationConfirmationRequired(true);
							operationConfirmationRequired.operationId =
								error['operationId'];
							Object.assign(operationConfirmationRequired, {otpId: operationConfirmationRequired.operationId});

							throw new HttpErrorResponse({
								error: operationConfirmationRequired,
								status: 601,
							});
						}
						if (
							event.body &&
							(event.body.errors || event.body.errorMessage)
						) {
							throw event.body;
						}
					}
				}),
				catchError((error: HttpErrorResponse) => this.handleError(error) as Observable<any>),
			);
	}

	/**
	 * fix method: в HttpErrorResponse.error приходит string а должен быть json
	 * @param httpErrorResponse
	 */
	private httpErrorResponseParse(
		httpErrorResponse: HttpErrorResponse,
	): HttpErrorResponse {
		let bodyError: any = null;
		// fix: в error.error приходит string а должен быть json
		if (typeof httpErrorResponse.error === 'string') {
			try {
				bodyError = JSON.parse(httpErrorResponse.error);
			} catch (parseError) {
				bodyError = httpErrorResponse.error;
			}
		} else {
			bodyError = httpErrorResponse.error;
		}

		Object.assign(httpErrorResponse, {error: bodyError});

		return httpErrorResponse;
	}

	private handleError(
		httpErrorResponse: HttpErrorResponse,
	): Observable<InternetbankAppApplicationException> {

		httpErrorResponse = this.httpErrorResponseParse(httpErrorResponse);

		const bodyError: any = httpErrorResponse.error;
		switch (httpErrorResponse.status) {
			case 0:
				return throwError(() => new NetworkConnectionProblemExecption(httpErrorResponse));
			/**
			 * bad request
			 */
			case 400: {
				const error = new MiddleValidationException(bodyError);
				Object.assign(error, bodyError);
				return throwError(() => error);
			}

			/**
			 * unauthorized
			 */
			case 401: {
				if (
					HttpClientExtension.modalService &&
					HttpClientExtension.modalService.open
				) {
					HttpClientExtension.modalService.open(
						LossSessionComponent.modalId,
					);
				}
				return throwError(() => new UnauthorizedException(httpErrorResponse));
			}

			/**
			 * клиент заблокирован
			 */
			case 403: {
				const exception: UserLockedException = new UserLockedException(httpErrorResponse);
				return throwError(() => exception);
			}

			/**
			 * ресурс не найден
			 */
			case 404: {
				const msg: string = 'Запрашиваемый ресурс не найден (404)';
				return throwError(() => new TechnicalException(msg));
			}
			/**
			 * требуется подтверждение операции
			 */
			case 601: // с воодом ОТП
			case 607:
			case 511: // с воодом ОТП
			case 517:
				{
					let otp: OperationConfirmationRequired = new OperationConfirmationRequired(true);

					if (
						httpErrorResponse.status === 607
						|| httpErrorResponse.status === 517
					) {
						otp = new OperationConfirmationRequired(false);
					}


					otp.operationId = bodyError.otpId;
					otp.attemptsText = bodyError.attemptsText;
					otp.otpNumber = bodyError.otpNumber;
					otp.confirmType = bodyError.confirmType;
					if (bodyError.additionalData) {
						otp.additionalData = bodyError.additionalData;
					}

					if (bodyError.operationConfirmationRequired) {
						Object.assign(otp, bodyError.operationConfirmationRequired);
						otp.operationId = bodyError.operationConfirmationRequired.otpId;
					}

					if (bodyError.confirmation) {
						Object.assign(otp, bodyError.confirmation);
						otp.operationId = bodyError.confirmation.otpId;
					}

					const additionalData: any = bodyError.additionalData;

					return throwError(() =>
						new OperationConfirmationRequiredException(
							httpErrorResponse,
							otp,
							additionalData,
							bodyError,
						),
					);
				}
			/**
			* требуется подтверждение операции через подписание документа
			*/
			case 608:
			case 518: {
				return throwError(() => {
					return new OperationSignDocumentRequiredException(
						{
							documentId: bodyError.documentId,
							operationId: bodyError.otpId,
						},
					)
				})
			}

			/**
			 * требуется изменение временного пароля
			 */
			case 611:
			case 521: {
				return throwError(() =>
					new TemporaryPasswordException(httpErrorResponse),
				);
			}
			/**
			 * требуется установка единого логина и пароля
			 */
			case 612:
			case 522: {
				return throwError(() =>
					new OtherSystemPasswordException(httpErrorResponse),
				);
			}

			/**
			 * ошибка при подтверждении ОТП
			 */
			case 610:
			case 520: {
				return throwError(() =>
					new OperationConfirmationRequiredValidationException(
						httpErrorResponse,
					),
				);
			}

			/**
			 * captcha required
			 */
			case 604:
			case 514: {
				return throwError(() => new CaptchaException(httpErrorResponse));
			}

			/**
			 * captcha validation error
			 */

			case 617:
			case 527: {
				return throwError(() => new CaptchaValidationException(httpErrorResponse));
			}

			/**
			 * ошибка бизнес-логики
			 */
			case 600:
			case 599: {
				return throwError(() => new OperationException(httpErrorResponse));
			}

			case 613:
			case 523: {
				return throwError(() => new OperationWithErrorCodeException(bodyError.ErrorText, bodyError.ErrorCode))
			}
			/**
			 * нетипичные ошибки бизнес-логики
			 */
			case 614:
			case 524: {
				return throwError(() =>
					new AtypicalOperationException(httpErrorResponse),
				);
			}

			case 616:
			case 526: {
				return throwError(() =>
					new OperationConfirmationExpiredException(httpErrorResponse),
				);
			}
			/**
			 * Бизнес ошибка от ЕИС с выводом текстовой информации
			 */
			case 620:
			case 530: {
				const errorContent: OperationInformationOutputContent = {
					errorMessage: bodyError.errorMessage,
					errorRecommendation: bodyError.errorRecommendation,
					errorType: bodyError.errorType,
				};

				return throwError(() => new OperationInformationOutputException(
					httpErrorResponse,
					errorContent,
				));
			}
			/**
			 * Бизнес ошибка с выводом сообщения ошибки
			 */
			case 621:
			case 531: {
				const errorContent: OperationInformationOutputContent = {errorMessage: bodyError.errors[0]};

				return throwError(() => new OperationInformationOutputException(
					httpErrorResponse,
					errorContent,
				));
			}
			/**
			 * Бизнес ошибка с выводом сообщения ошибки
			 */
			case 622:
			case 532: {
				const errorContent: OperationInformationOutputContent = {errorMessage: bodyError.errors[0]};

				return throwError(() => new SelfiePhotoRejectException(httpErrorResponse));
			}

			case 533: {
				return throwError(() => new MirPassIdUnregisteredException(httpErrorResponse))
			}

			case 618:
			case 528: {
				return throwError(() =>
					new BiometricsRegistrationClientExistsException(httpErrorResponse),
				);
			}

			case 619:
			case 529: {
				return throwError(() =>
					new BiometricsRegistrationDataRefinementException(httpErrorResponse),
				);
			}

			case 500:
			case 502:
			case 504: {
				return throwError(() =>
					new TechnicalException(ConstantsService.ERROR_TRY_AGAIN),
				);
			}

			default:
				if (!bodyError) {
					return throwError(() => httpErrorResponse);
				}

				if (bodyError.errors && bodyError.request) {
					return throwError(() =>
						Object.assign(new MiddleValidationException(), bodyError),
					);
				} else if (bodyError.errors || bodyError.errorMessages) {
					return throwError(() =>
						new TechnicalException(httpErrorResponse),
					);
				}
				break;
		}

		return throwError(() => new InternetbankAppApplicationException(httpErrorResponse));
	}
}
